// extracted by mini-css-extract-plugin
export var boxItems = "_9u-1";
export var boxItemsLg = "_9u-2";
export var button = "_9u-7";
export var buttonHoverless = "_9u-9";
export var buttonLg = "_9u-8";
export var filterGroupBox = "_9u-0";
export var icon = "_9u-3";
export var iconSecondary = "_9u-6";
export var iconWrapper = "_9u-4";
export var iconWrapperLg = "_9u-5";
export var truncatedLabel = "_9u-a";